module.exports = __webpack_public_path__ + "static/img/clearC_new_mobile.07f2de40.jpg";